import { render, staticRenderFns } from "./UnorderedList.vue?vue&type=template&id=2d8d76d0&scoped=true&"
import script from "./UnorderedList.vue?vue&type=script&lang=ts&"
export * from "./UnorderedList.vue?vue&type=script&lang=ts&"
import style0 from "./UnorderedList.vue?vue&type=style&index=0&id=2d8d76d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8d76d0",
  null
  
)

export default component.exports